import { Theme } from '@/types/theme'

// The manifest is served from a blob: URL (see channelLoader.ts), and manifest URL
// properties resolve relative to the manifest's own URL, not the page's — blob: URLs
// aren't a valid base for that resolution, so every URL here must be absolute.
function toAbsoluteUrl(path: string): string {
  return new URL(path, window.location.origin).toString()
}

export function buildManifest(theme: Theme) {
  return {
    name: theme.name,
    short_name: theme.name,
    start_url: toAbsoluteUrl('/'),
    scope: toAbsoluteUrl('/'),
    display: 'standalone',
    background_color: theme.colors.background,
    theme_color: theme.colors.primary,
    icons: [
      {
        src: toAbsoluteUrl(theme.pwaIcon192Url ?? '/pwa-192.png'),
        sizes: '192x192',
        type: 'image/png',
        purpose: 'any',
      },
      {
        // The Vendure "PWA Icon (512×512, maskable)" field asks tenants to upload an
        // already safe-padded icon, so this one asset covers both purposes.
        src: toAbsoluteUrl(theme.pwaIcon512Url ?? '/pwa-512.png'),
        sizes: '512x512',
        type: 'image/png',
        purpose: 'any maskable',
      },
    ],
  }
}
